import React from 'react';
import { Dropdown, Menu } from 'semantic-ui-react';
import styled from 'styled-components';

import IconButton from '../../../components/IconButton';
import {
  StandaloneChargeDTO,
  StandaloneChargeStatusEnum
} from '../../../services/standalone-charges';

type Props = {
  charge: StandaloneChargeDTO;
  canSend: boolean;
  canCancel: boolean;
  canRenew: boolean;
  canRefund: boolean;
  loading: boolean;
  onCopyLink: (link: string, chargeId: string) => void;
  onResendEmail: (id: string) => void;
  onCancel: (charge: StandaloneChargeDTO) => void;
  onRenew: (id: string) => void;
  onRefund: (charge: StandaloneChargeDTO) => void;
};

const ActionsDropdownMenu = styled(Dropdown.Menu)`
  &&& {
    min-width: 190px;
    width: 190px;
    z-index: 9999;
  }
`;

const ChargeActionsMenu: React.FC<Props> = ({
  charge,
  canSend,
  canCancel,
  canRenew,
  canRefund,
  loading,
  onCopyLink,
  onResendEmail,
  onCancel,
  onRenew,
  onRefund
}) => {
  const isPaid = charge.status === StandaloneChargeStatusEnum.paid;
  const isPending = charge.status === StandaloneChargeStatusEnum.pendingPayment;
  const isExpired = charge.status === StandaloneChargeStatusEnum.expired;
  const hasActions =
    (isPaid && canRefund) ||
    isPending ||
    (isPending && canSend) ||
    (isPending && canCancel) ||
    (isExpired && canRenew);

  return (
    <Menu compact>
      <Menu.Item>
        <Dropdown
          trigger={<IconButton name="ellipsis vertical" />}
          icon={null}
          direction="left"
          disabled={!hasActions || loading}
        >
          <ActionsDropdownMenu>
            {isPaid && canRefund && (
              <Dropdown.Item
                icon="undo alternate"
                text="Estornar valor"
                onClick={() => onRefund(charge)}
              />
            )}
            {isPending && (
              <Dropdown.Item
                icon="copy outline"
                text="Copiar link"
                onClick={() => onCopyLink(charge.chargeLinkUrl, charge.id)}
              />
            )}
            {isPending && canSend && (
              <Dropdown.Item
                icon="mail"
                text="Reenviar e-mail"
                onClick={() => onResendEmail(charge.id)}
              />
            )}
            {isPending && canCancel && (
              <Dropdown.Item
                icon="ban"
                text="Cancelar"
                onClick={() => onCancel(charge)}
              />
            )}
            {isExpired && canRenew && (
              <Dropdown.Item
                icon="redo"
                text="Renovar cobrança"
                onClick={() => onRenew(charge.id)}
              />
            )}
          </ActionsDropdownMenu>
        </Dropdown>
      </Menu.Item>
    </Menu>
  );
};

export default ChargeActionsMenu;
